/* Pixel Kreation — Unlearning "Slow" sales page behaviour.
   No tracking code here on purpose: the Facebook & Instagram app already
   sends ViewContent / InitiateCheckout / Purchase. Adding fbq() here would
   duplicate events. */
(function () {
  var d = document, root = d.documentElement;
  window.PKUS = true; /* tells the inline guard in pk-us-hero that this file loaded */
  root.classList.add('pk-js');
  if ('IntersectionObserver' in window) root.classList.add('pk-io');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    /* 1. Scroll reveals */
    var els = d.querySelectorAll('[data-pk-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }

    d.querySelectorAll('[data-pk-cta]').forEach(function (button) {
      button.classList.add('rzp-magic-btn__buy-product');
    });

    /* 3. Sticky bar: visible whenever no buy button is on screen */
    var sticky = d.querySelector('[data-pk-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var seen = new Set();
      var targets = d.querySelectorAll('[data-pk-cta]:not([data-pk-sticky-btn]), [data-pk-native]');
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); });
        var on = seen.size === 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        d.body.classList.toggle('pk-sticky-on', on);
      }, { threshold: 0 });
      targets.forEach(function (t) { so.observe(t); });
    }
  });
})();
